export enum RatingKeyType {
    Company = 1,
    Special = 2,
    Eflyer = 3,
    Product = 4
}

export enum ReviewKeyType {
    Company = 1,
    Special = 2,
    Eflyer = 3,
    Product = 4
}

export enum PostCategory {
    Jobs = 1,
    Internships = 2,
    Apprenticeship = 3,
    Articles = 4,
    PropertyToRent = 5,
    Tender = 6,
    IndustryTrends = 7,
    Bursary = 8,
    Blog = 9,
}

export enum Tenure {
    OneMonth = 1,
    ThreeMonths = 3,
    SixMonths = 6,
    TwelveMonths = 12,
} 